import { NotificationMessage, INotificationMessage } from '@numeo/types'
import { WsMessageCategory } from '@numeo/types-core'
import { Category } from 'hooks/useNotification'
import { AppDispatch } from 'store'
import { addNotification } from 'store/notificationSlice'
import { audioService } from 'utils/audioService'
import { playNotificationSoundIfEnabled } from 'utils/notificationSoundUtils'
import { showSuccess, showWarning, showError } from 'utils/snackbar'

export const handleNotificationMessage = (message: NotificationMessage, dispatch: AppDispatch) => {
    if (message.categoryType !== WsMessageCategory.Notification || !message.data) {
        return
    }

    const notificationData = message.data as INotificationMessage
    const { type, message: notificationMessage, timestamp, temp, sound } = notificationData

    if (temp) {
        switch (type) {
            case 'info':
                showSuccess(notificationMessage)
                break
            case 'warning':
                showWarning(notificationMessage)
                break
            case 'error':
                showError(notificationMessage)
                break
        }
        return
    }

    // Dispatch the notification to the Redux store
    dispatch(
        addNotification({
            id: `notification-${Date.now()}`,
            message: notificationMessage,
            type: type,
            category: Category.System,
            timestamp: timestamp || Date.now(),
        })
    )
    if (sound === true) {
        playNotificationSoundIfEnabled(audioService)
    }
}
